import { HttpClient } from "../http";

export interface InstagramComment {
  id: string;
  text: string;
  timestamp: string;
  username: string;
  from?: { id: string; username: string };
}

export class CommentService extends HttpClient {
  constructor() {
    super(process.env.NEXT_PUBLIC_API_URL!);
  }

  async getComments(accountId: string, mediaId: string) {
    return this.get<InstagramComment[]>(
      `/api/instagram/accounts/${accountId}/media/${mediaId}/comments`
    );
  }

  async replyToComment(accountId: string, mediaId: string, commentId: string, message: string) {
    return this.post<{ id: string }>(
      `/api/instagram/accounts/${accountId}/media/${mediaId}/comments/${commentId}/reply`,
      { message }
    );
  }

  async editComment(accountId: string, mediaId: string, commentId: string, message: string, parentCommentId: string) {
    return this.patch<{ id: string }>(
      `/api/instagram/accounts/${accountId}/media/${mediaId}/comments/${commentId}`,
      { message, parentCommentId }
    );
  }

  async deleteComment(accountId: string, mediaId: string, commentId: string) {
    return this.delete<{ success: boolean }>(
      `/api/instagram/accounts/${accountId}/media/${mediaId}/comments/${commentId}`
    );
  }
}
